<app-header></app-header>
<div class="main-container d-flex">
    <app-sidebar></app-sidebar>
    <div class="container-fluid h-100p overflow-y-scroll leaderboard-page-shell">
        <div class="leaderboard-page">
            <!-- Breadcrumb -->
            <div class="breadcrumb-container mb-3">
                <a [routerLink]="['/contact-directory']" class="breadcrumb-link">
                    Back to Directory
                </a>
                <span class="breadcrumb-separator">›</span>
                <span class="breadcrumb-current-amber">Leaderboard</span>
            </div>

            <!-- Hero -->
            <div class="leaderboard-hero">
                <div class="leaderboard-hero-title">
                    <div class="leaderboard-hero-trophy">
                        <i class="fas fa-trophy"></i>
                    </div>
                    <h2 class="leaderboard-hero-heading">Leaderboard</h2>
                </div>
                <p class="leaderboard-hero-subtitle">
                    Top contributors who help keep the directory updated
                </p>
            </div>

            <!-- Podium -->
            <div class="leaderboard-podium-grid" *ngIf="top3Entries.length > 0">
                <div class="podium-card podium-2" *ngIf="top3Entries[1] as podium2">
                    <div class="podium-medal">2</div>
                    <div class="podium-avatar podium-avatar-2">
                        <img *ngIf="podium2.imageUrl" [src]="podium2.imageUrl" alt="" class="podium-avatar-img" (error)="onContributorImageError(podium2)" />
                        <span *ngIf="!podium2.imageUrl">{{ getInitials(podium2.displayName) }}</span>
                    </div>
                    <p class="podium-name">{{ podium2.displayName }}</p>
                    <p class="podium-credits">{{ podium2.credits }} pts</p>
                    <p class="podium-subtext">{{ podium2.contributions }} contributions</p>
                </div>

                <div class="podium-card podium-1" *ngIf="top3Entries[0] as podium1">
                    <div class="podium-medal podium-medal-lg">1</div>
                    <div class="podium-avatar podium-avatar-1">
                        <img *ngIf="podium1.imageUrl" [src]="podium1.imageUrl" alt="" class="podium-avatar-img" (error)="onContributorImageError(podium1)" />
                        <span *ngIf="!podium1.imageUrl">{{ getInitials(podium1.displayName) }}</span>
                    </div>
                    <p class="podium-name">{{ podium1.displayName }}</p>
                    <p class="podium-credits">{{ podium1.credits }} pts</p>
                    <p class="podium-subtext">{{ podium1.contributions }} contributions</p>
                </div>

                <div class="podium-card podium-3" *ngIf="top3Entries[2] as podium3">
                    <div class="podium-medal">3</div>
                    <div class="podium-avatar podium-avatar-3">
                        <img *ngIf="podium3.imageUrl" [src]="podium3.imageUrl" alt="" class="podium-avatar-img" (error)="onContributorImageError(podium3)" />
                        <span *ngIf="!podium3.imageUrl">{{ getInitials(podium3.displayName) }}</span>
                    </div>
                    <p class="podium-name">{{ podium3.displayName }}</p>
                    <p class="podium-credits">{{ podium3.credits }} pts</p>
                    <p class="podium-subtext">{{ podium3.contributions }} contributions</p>
                </div>
            </div>

            <!-- Table -->
            <div class="leaderboard-table-wrap">
                <div class="leaderboard-table-scroll">
                    <table class="leaderboard-table">
                        <thead>
                            <tr>
                                <th>Rank</th>
                                <th>Contributor</th>
                                <th>Credits</th>
                                <th>Contributions</th>
                                <th>Approved</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngIf="isLoading">
                                <td colspan="5">
                                    <div class="leaderboard-loading">Loading…</div>
                                </td>
                            </tr>

                            <tr *ngIf="!isLoading && leaderboardData.length === 0">
                                <td colspan="5">
                                    <div class="leaderboard-empty">No leaderboard data found</div>
                                </td>
                            </tr>

                            <tr *ngFor="let entry of leaderboardData" class="leaderboard-row">
                                <td class="lb-rank-cell">
                                    <span class="lb-rank-pill" [ngClass]="entry.rank <= 3 ? 'lb-rank-pill-top' : 'lb-rank-pill-rest'">
                                        {{ getEntryMedal(entry.rank) }}
                                    </span>
                                </td>
                                <td class="lb-contributor-cell">
                                    <div class="lb-contributor">
                                        <img *ngIf="entry.imageUrl" [src]="entry.imageUrl" alt="" class="lb-avatar-img" (error)="onContributorImageError(entry)" />
                                        <div *ngIf="!entry.imageUrl" class="lb-avatar-placeholder" [attr.aria-label]="entry.displayName">
                                            {{ getInitials(entry.displayName) }}
                                        </div>
                                        <span class="lb-contributor-name">{{ entry.displayName }}</span>
                                    </div>
                                </td>
                                <td class="lb-credits-cell">{{ entry.credits }}</td>
                                <td class="lb-contributions-cell">{{ entry.contributions }}</td>
                                <td class="lb-approved-cell">{{ entry.approved }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <!-- Make Contribution -->
            <!-- <div class="leaderboard-cta-row">
                <button class="btn-contribute leaderboard-cta-btn" (click)="onMakeContribution()">
                    Make Your Contribution
                </button>
            </div> -->
        </div>
    </div>
</div>